import React from "react";
import { HiOutlineX } from "react-icons/hi";

interface CloseButtonProps {
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const index: React.FC<CloseButtonProps> = ({ setIsModalOpen }) => {
    return (
        <button
            className="bg-gray-100 rounded-full p-1"
            onClick={() => setIsModalOpen(false)}
        >
            <HiOutlineX size={25} />
        </button>
    );
};

export default index;
